import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Dropdown } from 'react-bootstrap'
import { FaBars, FaBell, FaUser, FaSignOutAlt, FaBuilding, FaSearch } from 'react-icons/fa'
import { logoutUser } from '../../store/slices/authSlice'
import '../../assets/scss/components/Header.scss'
import { useTheme } from '../../context/ThemeContext'
import { FaSun, FaMoon } from 'react-icons/fa'

const Header = ({ toggleSidebar }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { theme, toggleTheme } = useTheme()
  const { user } = useSelector(state => state.auth)
  const [notifications] = useState([])

  const handleLogout = () => {
    dispatch(logoutUser())
    navigate('/login')
  }

  return (
    <header className="app-header">
      <div className="header-left">
        <button className="btn-toggle-sidebar" onClick={toggleSidebar} aria-label="Toggle sidebar">
          <FaBars />
        </button>
        <div className="header-search d-none d-lg-flex">
          <FaSearch className="search-icon" />
          <input type="text" placeholder="Search trucks, drivers, requests..." />
        </div>
      </div>

      <div className="header-right">
        <button className="header-icon-btn" onClick={toggleTheme} aria-label="Toggle theme">
          {theme === 'dark' ? <FaSun /> : <FaMoon />}
        </button>
        <Dropdown className="header-dropdown">
          <Dropdown.Toggle variant="link" className="header-icon-btn">
            <FaBell />
            {notifications.length > 0 && (
              <span className="notification-badge">{notifications.length}</span>
            )}
          </Dropdown.Toggle>
          <Dropdown.Menu align="end" className="notification-dropdown">
            <div className="dropdown-header">
              <h6>Notifications</h6>
            </div>
            {notifications.length > 0 ? (
              notifications.map((notif, idx) => (
                <Dropdown.Item key={idx}>{notif.message}</Dropdown.Item>
              ))
            ) : (
              <div className="empty-notifications">
                <FaBell className="empty-icon" />
                <p>No new transmissions</p>
              </div>
            )}
          </Dropdown.Menu>
        </Dropdown>

        {/* User Profile */}
        <Dropdown className="header-dropdown">
          <Dropdown.Toggle variant="link" className="user-dropdown-toggle">
            <div className="user-avatar">
              <FaUser />
            </div>
            <div className="user-info d-none d-md-flex flex-column text-start">
              <span className="user-name lh-1">{user?.name || 'User'}</span>
              <span className="user-role small opacity-75">{user?.role || 'ADMIN'}</span>
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu align="end" className="user-dropdown">
            <div className="dropdown-profile-header">
              <div className="user-avatar-lg">
                <FaUser />
              </div>
              <div className="user-details">
                <h6>{user?.name}</h6>
                <small>{user?.email}</small>
              </div>
            </div>
            <Dropdown.Divider />
            <Dropdown.Item as={Link} to="/company/profile" className="profile-item">
              <FaBuilding /> <span>Profile</span>
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item onClick={handleLogout} className="profile-item logout text-danger">
              <FaSignOutAlt /> <span>Logout</span>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </header>
  )
}

export default Header
